import { localStorageHelper } from './local-storage-helper';

const storage = new localStorageHelper('instant-config-lock', 1000);

export function lock(): boolean {
	if (storage.get() === 'lock') {
		return true;
	}

	storage.set('lock');

	return false;
}

export function release(): void {
	storage.set(null);
}
